// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1r5sl","paramInput":"JobSimulator_paramInput__1NUx5","input":"JobSimulator_input__2_ihb"};